export default "__VITE_ASSET__Bwlf7X7F__"